import React, { useState } from "react";
import { TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import { FaRegEdit } from "react-icons/fa";
import { HiOutlineTrash } from "react-icons/hi";
import { Form } from "react-bootstrap";
import {
  useDeleteUserManagementMutation,
  useUpdateUserManagementMutation,
} from "../../../Service/userManagment";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import PermissionCheck from "../../../Component/PermissionCheck";

interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  state: any;
  setstates: any;
  setUser: any;
  refetch: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  orderBy,
  handleClick,
  handleChange,
  state,
  setstates,
  stableSort,
  setUser,
  refetch,
}: props) {
  const [check, setcheck] = useState(false);
  const [deleteUserManagement] = useDeleteUserManagementMutation();
  const [updateUserManagement] = useUpdateUserManagementMutation();
  const { open, message, openDelete, deleteId } = useDeleteBox();

  const onClick = (user) => {
    setUser(user);
    setstates(!state);
  };
  // const onDelete = (user) => {
  //   deleteUserManagement(user.id);
  // };

  const onChangeCheck = (user, value) => {
    updateUserManagement({
      id: user.id,
      active_status: value ? 1 : 0,
    });
  };
  const Delete = async (bool) => {
    if (bool) {
      await deleteUserManagement(deleteId);
      refetch();
    }
    openDelete("Are you sure you want to delete this user?", false, null);
  };
  return (
    <>
      <>
        <AlertDialog open={open} message={message} deleteBranches={Delete} />
      </>
      {stableSort(customer_list, getComparator(order, orderBy)).map((a, i) => {
        return (
          <TableRow
            hover
            onClick={(event) => handleClick(event, a.id)}
            role="checkbox"
            tabIndex={-1}
            key={i}
          >
            <TableCell align="center">
              <div className="d-flex">
                {/* <div className="rounded">
                  <img
                    src={require("../../../assets/DigitalMarketing/image/3.jpg")}
                    className="rounded-circle"
                  />
                </div> */}
                <span
                  className="mx-2"
                  style={{ textAlign: "left", width: "150px" }}
                >
                  {a.fullName}{" "}
                </span>
              </div>
            </TableCell>
            <TableCell align="left">
              <div className="d-flex">
                {/* <Form.Check
                  type="switch"
                  id="custom-switch"
                  onChange={(e) => onChangeCheck(a, e.target.checked)}
                  checked={a.activeStatus === 1}
                  // label={check ? "Active" : "Inactive"}
                /> */}
                {a.activeStatus === 1 ? (
                  <span className="mx-2 active-tb">Active</span>
                ) : (
                  <span className="mx-2 inactive-tb">Inactive</span>
                )}
              </div>
            </TableCell>
            <TableCell
              style={{ textAlign: "left", width: "150px" }}
              align="left"
            >
              {a.email}
            </TableCell>
            <TableCell align="left">{a.phoneNumber}</TableCell>

            <TableCell align="left">{a.roleName}</TableCell>
            {a.roleName !== "super_admin" && (
              <TableCell align="center">
                <div className="d-flex">
                  <img
                    src={edit}
                    className="blue-c action-icon cursur me-2"
                    onClick={() => onClick(a)}
                  />
                  <img
                    src={dele}
                    onClick={() =>
                      openDelete(
                        "Are you sure you want to delete this user?",
                        true,
                        a.id
                      )
                    }
                    className="delete-icon cursur action-icon"
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
